import { useState } from "react";
import { useTranslations } from "next-intl";
import Button from "../../../core/Button";
import moment from "moment";
import { useCurrentUser, usePostFeedbackRating } from "@hooks/use-current-user";
import gtm from "@lib/gtm";
import feedbackRatingPredictedLtv from "@utils/feedbackRatingPredictedLtv";

function SwapUserFeedbackRating({ setFeedbackId, setDisplayCommentModalContent }) {
  const t = useTranslations("feedbacks");
  const postFeedbackRating = usePostFeedbackRating();
  const user = useCurrentUser();

  const ratings = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [displayRatingsModalContent, setDisplayRatingsModalContent] = useState(true);
  const [loading, setLoading] = useState(false);

  function sendPltv(rating) {
    if (!user || !user.subscribe_at || user.state !== "subscriber") return;
    if (moment().diff(moment(user.subscribe_at), "days") >= 7) return;

    const now = Math.floor(Date.now() / 1000);
    const subscriptionCount = user.subscription?.subscription_count;

    gtm(
      {
        event: "AppendValue",
        event_time: now,
        original_event_data: {
          event_name: "subscription_success_with_address",
          event_id: `subscription_success_with_address-${user.uid}-${subscriptionCount}`,
        },
        custom_data: {
          predicted_ltv: feedbackRatingPredictedLtv[rating],
          currency: "EUR",
        },
      },
      user,
    );
  }

  async function saveRating(rating) {
    if (loading) return;

    try {
      setLoading(true);
      const res = await postFeedbackRating(rating);
      setFeedbackId(res.data.id);
      sendPltv(rating);
    } finally {
      setLoading(false);
      setDisplayRatingsModalContent(false);
      setDisplayCommentModalContent(true);
    }
  }

  return (
    <div className={displayRatingsModalContent ? "swap-feedback-content-ratings" : "d-none"}>
      <div className="swap-feedback-title">{t("do_you_like_the_choice_of_clothes")}</div>
      <div className="swap-feedback-ratings">
        {ratings.map((i) => (
          <Button
            key={`feedback-btn-${i}`}
            name="rating"
            size="xs"
            square
            variant="primary"
            onClick={() => saveRating(i)}
            disabled={loading}
          >
            {i}
          </Button>
        ))}
      </div>
      <div className="swap-feedback-captions">
        <p>{t("not_at_all")}</p>
        <p>{t("perfectly")}</p>
      </div>
    </div>
  );
}

export default SwapUserFeedbackRating;
